import React from 'react';
import Lottie from 'react-lottie';
import animationData from './spinner.json';

type Props = {
  width?: number;
  height?: number;
};

function Spinner(props: Props) {
  const { width = 40, height = 40 } = props;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Lottie
      options={defaultOptions}
      height={height}
      width={width}
    />
  );
}

export default Spinner;
